import { http } from './client';
import { API_ROUTES } from './routes';

export type CrmConnectionStatus = 'active' | 'inactive' | 'pending' | 'revoked';

export interface ICrmConnection {
  id: string;
  companyId: string;
  serviceId: string;
  unifiedApi: string;
  status: CrmConnectionStatus;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface IVaultSessionResponse {
  sessionToken: string;
  sessionUri: string;
}

export const apideckApi = {
  createVaultSession: (): Promise<IVaultSessionResponse> =>
    http.post(API_ROUTES.apideck.createVaultSession).then((r) => r.data),

  listConnections: (): Promise<ICrmConnection[]> =>
    http.get(API_ROUTES.apideck.listConnections).then((r) => r.data),

  deleteConnection: (id: string): Promise<void> =>
    http.delete(API_ROUTES.apideck.deleteConnection(id)).then((r) => r.data),
};
